"use client";
import NextImage from "next/image";
import { cloudflareLoader, evaluateSrc } from "./imageLoader";

export default function Image(props: Parameters<typeof NextImage>[0]) {
  const data = evaluateSrc(props.src);

  if (data.type === "already-optimized") {
    // For already-optimized images, return regular img tag to avoid unnecessary processing
    const { src, fill, ...rest } = props;
    // eslint-disable-next-line @next/next/no-img-element
    return <img src={data.src} {...rest} />;
  }

  if (data.type === "local") return <NextImage {...props} />;

  return <NextImage {...props} loader={cloudflareLoader} />;
}
